import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const offeringsRoutes: RouteRecordRaw[] = [
  // Tokenisation queue — fully-funded offerings awaiting on-chain token issuance.
  // The funding lifecycle stage after "Fully Funded & Completed". Data is sourced
  // via the orders service (GET /orders/awaiting-tokenisation), which consumes the
  // property domain's awaiting-tokenisation query for its dashboard KPI.
  {
    path: routes.TOKENISATION,
    name: 'TOKENISATION',
    component: () => import('./pages/TokenisationPage.vue'),
    meta: { requiresAuth: true, title: 'Tokenisation Queue' },
  },

  // Offering-property configuration / form
  {
    path: routes.OFFERING_PROPERTY,
    redirect: routes.OFFERING_CONFIGURE,
  },
  {
    path: routes.OFFERING_CONFIGURE,
    name: 'OFFERING_CONFIGURE',
    component: () => import('./pages/PropertyOfferingFormPage.vue'),
    meta: { requiresAuth: true, permission: 'super_admin', activeMenu: 'Offering Property' },
  },
  {
    path: routes.PROPERTY_OFFERING_FORM,
    name: 'PROPERTY_OFFERING_FORM',
    component: () => import('./pages/PropertyOfferingFormPage.vue'),
    meta: { requiresAuth: true, permission: 'super_admin', activeMenu: 'Offering Property' },
  },

  // Offerings — filtered views
  { path: routes.OFFERINGS, redirect: routes.OFFERINGS_ALL },
  {
    path: routes.OFFERINGS_ALL,
    name: 'OFFERINGS_ALL',
    component: () => import('./pages/OfferingsAllPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Offerings' },
  },
  {
    path: routes.OFFERINGS_DRAFTS,
    name: 'OFFERINGS_DRAFTS',
    component: () => import('./pages/OfferingsDraftsPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Offerings' },
  },
  {
    path: routes.OFFERINGS_PENDING_APPROVAL,
    name: 'OFFERINGS_PENDING_APPROVAL',
    component: () => import('./pages/OfferingsPendingApprovalPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Offerings' },
  },
  {
    path: routes.OFFERINGS_VASP_ONBOARDING,
    name: 'OFFERINGS_VASP_ONBOARDING',
    component: () => import('./pages/OfferingsVaspOnboardingPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Offerings' },
  },
  {
    path: routes.OFFERINGS_LIVE,
    name: 'OFFERINGS_LIVE',
    component: () => import('./pages/OfferingsLivePage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Offerings' },
  },
  {
    path: routes.OFFERINGS_FULLY_FUNDED,
    name: 'OFFERINGS_FULLY_FUNDED',
    component: () => import('./pages/OfferingsFullyFundedPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Offerings' },
  },
  {
    path: routes.OFFERINGS_REJECTED,
    name: 'OFFERINGS_REJECTED',
    component: () => import('./pages/OfferingsRejectedPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Offerings' },
  },

  // Read-only single-offering detail (drill-in from property Overview + queues)
  {
    path: routes.OFFERING_DETAILS,
    name: 'OFFERING_DETAILS',
    component: () => import('./pages/OfferingDetailsPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Offerings' },
  },
]
